import React, { useCallback } from 'react';
import { useHaptic } from '../hooks/useHaptic';

interface QuickActionsProps {
  onAction: (action: string) => void;
}

export const QuickActions: React.FC<QuickActionsProps> = React.memo(
  function QuickActions({ onAction }) {
    const { trigger } = useHaptic();

    const handle = useCallback(
      (action: string) => {
        trigger('medium');
        onAction(action);
      },
      [onAction, trigger]
    );

    return (
      <div className="quick-actions" role="group" aria-label="Quick actions">
        <button
          className="quick-action-btn chat"
          onClick={() => handle('chat')}
          aria-label="Quick chat"
        >
          💬
        </button>
        <button
          className="quick-action-btn write"
          onClick={() => handle('write')}
          aria-label="Quick write"
        >
          ✍️
        </button>
        <button
          className="quick-action-btn decree"
          onClick={() => handle('decree')}
          aria-label="Quick decree"
        >
          📜
        </button>
        <button
          className="quick-action-btn voice"
          onClick={() => handle('voice')}
          aria-label="Quick voice"
        >
          🎙️
        </button>
      </div>
    );
  }
);

export default QuickActions;
